import { render, staticRenderFns } from "./BackupView.vue?vue&type=template&id=68756603&scoped=true&"
import script from "./BackupView.vue?vue&type=script&lang=js&"
export * from "./BackupView.vue?vue&type=script&lang=js&"
import style0 from "./BackupView.vue?vue&type=style&index=0&id=68756603&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68756603",
  null
  
)

export default component.exports